import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  root: {
    maxWidth: '100%',
  },
  media: {
    height: '0',
    paddingTop: '100%', // 16:9
  },
  cardActions: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  cardContent: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  spanMargin:{
    marginLeft: '10px',
    float: 'right',
    fontWeight: 'bold',
    color: 'purple',
    fontFamily: 'Arial, Helvetica, sans-serif'
  },
  learnMore:{
    float: 'right',
    fontSize: '11px',
  },
 
}));